import { token } from "@planningcenter/tapestry"

export default {
  fill: token("--t-surface-color-card"),
  stroke: token("--t-border-color-control-neutral"),
  focusStroke: token("--t-border-color-control-info"),
  checkedFill: token("--t-fill-color-control-primary"),
  checkedStroke: token("--t-border-color-control-info"),
}
